'use strict';

angular.module('shiftTraderApp')
  .factory('Departments', function (ServerUrls, $http, $q) {
    var path = ServerUrls.current.railsApi + 'departments/';

    var Department = function(initData) {
      var dept = {};
      angular.extend(dept, initData);

      dept.$update = function(data) {
        var that = this;
        return $http.put(path + this.id, _.assign({organization_id: this.organization_id}, data))
          .then(function(response) {
            angular.extend(that, _.omit(response.data, 'positions'));  //copy in new properties from server
            return $q.resolve(response.data);
          }, function(response) {
            return $q.reject(response);
          });
      };

      dept.$makeInactive = function() {
        var that = this;
        return this.$update({active: false})
          .then(function(data) {
            that.active = data.active;
            return data;
          }, function(response) {
            console.log('department.makeInActive failed');
            return $q.reject(response);
          });
      };

      dept.$makeActive = function() {
        var that = this;
        return this.$update({active: true})
          .then(function(data) {
            that.active = data.active;
            return data;
          }, function(response) {
            console.log('didnt makeActive properly');
            return $q.reject(response);
          });
      };
      return dept;
    };

    var Departments = {};
    Departments.getById = function (id) {
      return $http.get(path + id)
        .then(function(response) {
          return new Department(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Departments.getAll = function(data) {
      var config = {};
      if (data) {
        config = {
          params: data
        };
      }

      return $http.get(path, config)
        .then(function(response) {
          return _.map(response.data, function(dept) {
            return new Department(dept);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    Departments.create = function (data) {
      return $http.post(path, {department: data})
        .then(function(response) {
          return new Department(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Departments.initWithData = function(initData) {
      return new Department(initData);
    };

    return Departments;
  });
